import { render, staticRenderFns } from "./trasladosStocks.vue?vue&type=template&id=e4b227f2&"
import script from "./trasladosStocks.vue?vue&type=script&lang=js&"
export * from "./trasladosStocks.vue?vue&type=script&lang=js&"
import style0 from "./trasladosStocks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports